<template>
  <div>
    <div>
      <input type="file" ref="file" style="display: none" @change="onChange" />
      <div v-if="loading">
        <v-progress-linear indeterminate value="0"></v-progress-linear>
      </div>
      <div class="rounded-card" :class="totop" @dragover.prevent @drop="onDrop" flat>
        <div class="pb-4 float-left width-full">
          <div v-if="dragging" class="drop align-center" @dragover.prevent @drop="onDrop">
            <div class="helper"></div>
            <label class="btn display-inline">
              <v-icon color="#808F9C" size="50px">cloud_upload</v-icon>
              <div>{{message}}</div>
              <input type="file" ref="file" name="image" @change="onChange" />
            </label>
          </div>

          <div v-if="!dragging" class="width-full float-left">
            <v-textarea
              v-on:keyup.enter="upload"
              class="custom"
              @click="edit=true"
              v-model="description"
              ref="message"
              color="#4dbac0"
              rows="1"
              auto-grow
              label="Add note..."
              hide-details
              clearable
              rounded
              :disabled="loading"
              :v-html="messageHTML"
            >
              <template slot="append">
                <div class="image-upload">
                  <label for="file-input" @click="$refs.file.click()">
                    <v-btn icon>
                      <v-icon>attach_file</v-icon>
                    </v-btn>
                  </label>

                  <input id="file-input" type="file" />
                </div>
              </template>
            </v-textarea>

            <div class="list-card-parrent">
              <v-card class="list-card" :elevation="4">
                <div
                  v-for="user in whistlerArr"
                  :key="user.username"
                  @click="addName(user.username)"
                  class="whistler-row pointer"
                >
                  <div class="float-left">
                    <Avatar
                      v-if="user.avatar != null"
                      class
                      :src="`https://tradeinpool.com/upload/${user.avatar}.png`"
                      :size="40"
                    ></Avatar>
                    <Avatar v-else class :username="user.username" :size="40"></Avatar>
                  </div>
                  <div class="float-left pt-3 ml-3">{{user.username}}</div>
                </div>
              </v-card>
            </div>
          </div>

          <div v-if="image.length >0" class="width-full float-left mt-4">
            <transition-group name="list">
              <div
                v-for="(img,index) in image"
                :key="img"
                class="display-inline align-center"
                v-bind:class="{ 'image': true }"
              >
                <img :src="img" alt class="img mx-4" />

                <span class="delete" @click="removeFile(index)">
                  <v-icon color="#E62163" size="30" dark>cancel</v-icon>
                </span>
              </div>
            </transition-group>
          </div>
          <!--
        <div v-if="edit" class="width-full float-left px-2">
          <v-card-actions>
            <v-btn @click="clearEdit" text>Cancel</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="upload" text>SAVE</v-btn>
          </v-card-actions>
        </div>
          -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Avatar from "vue-avatar";
import axios from "axios";
export default {
  components: {
    Avatar
  },
  props: { parentId: String, parentType: String, subtype: String, emitUser: String },
  data() {
    return {
      usersNotify: [],
      whistlerArr: [],
      actualName: "",
      watchingName: false,
      atIndex: null,
      response: "",
      loading: false,
      uploading: false,
      image: [],
      file: [],
      message: "Drag files here !",
      description: "",
      edit: false,
      dragging: false,
      model: this.value,
      totop: "totop-off",
      dimmer: "dimmer-off",
      inputRows: 1
    };
  },
  mounted() {},
  beforeDestroy() {},
  watch: {
    emitUser: function(newVal){
      if(newVal){
        this.description += "@"+newVal+": "
        this.$refs.message.focus();
        //this.$vuetify.goTo("#timeline-input", {offset: 10})
        this.scrollToId()
      }
    },
    edit: function(newVal) {
      if (newVal === true) {
        this.totop = "totop";
        this.dimmer = "dimmer";
        this.inputRows = 4;
      } else {
        this.totop = "totop-off";
        this.dimmer = "dimmer-off";
        this.inputRows = 1;
      }
    },
    description: function(newVal, oldVal) {
      if (oldVal.slice(-1) == "@" && oldVal.length > newVal.length) {
        this.watchingName = false;
        this.actualName = null;
        this.whistlerArr = [];
      }
      if (this.watchingName) {
        this.actualName = newVal.slice(this.atIndex + 1, newVal.length);
        if (this.actualName.length >= 2) {
          this.nameWhistler();
        }
      }
      if (newVal.slice(-1) == "@") {
        this.watchingName = true;
        this.atIndex = newVal.length - 1;
      }
      if (newVal == "" || newVal == null) {
        this.watchingName = false;
        this.whistlerArr = [];
        this.actualName = null;
      }
      if (newVal.slice(-1) == " " && this.watchingName) {
        this.watchingName = false;
        this.actualName = null;
        this.whistlerArr = [];
        // push name
      }
    }
  },
  methods: {
    scrollToId() {
      //setTimeout(() => {
      var element = document.getElementById("timeline-input");
      var headerOffset = 0;
      var elementPosition = element.getBoundingClientRect().top;
      var offsetPosition = elementPosition - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });

      //document
      //  .getElementById(this.$route.params.message)
      //  .scrollIntoView({ block: "start", behavior: "smooth" });
      //}, 500);
    },
    addName(name) {
       
      this.description =
        this.description.slice(0, this.atIndex + 1) + name + " ";
      this.watchingName = false;
      this.whistlerArr = [];
      this.actualName = null;
      this.$refs.message.focus();
      this.$refs.message.innerHTML = "<b>hooovno</b>";
    },
    nameWhistler() {
      axios
        .post("https://tradeinpool.com:3001/api/request/user/", {
          method: "whistler",
          data: this.actualName
        })
        .then(response => {
          this.whistlerArr = response.data;
        });
    },
    clearEdit() {
      this.description = "";
      this.image = [];
      this.file = [];
      this.edit = false;
      var thiis = this;
      setTimeout(() => {
        thiis.loading = false;
      }, 500);
    },
    dropfalse: function(e) {
      e.stopPropagation();
      e.preventDefault();
      //alert("drpoe");
      this.dragging = false;
      if (this.description == "" && this.image.length == 0) {
        this.edit = false;
        this.totop = "totop-off";
        this.dimmer = "dimmer-off";
      }
    },
    dragenter: function(e) {
      e.stopPropagation();
      e.preventDefault();
      this.edit = true;
      this.dragging = true;
      this.message = "Drop here !";
      this.totop = "totop";
    },
    dragleave: function(e) {
      e.stopPropagation();
      e.preventDefault();
      this.edit = false;
      this.dragging = false;
      this.message = "Drag files here !";
      this.totop = "";
      this.dimmer = "dimmer-off";
    },

    // image upload workaround
    onDrop: function(e) {
      e.stopPropagation();
      e.preventDefault();
      this.edit = true;
      this.dragging = false;
      var files = e.dataTransfer.files;

      this.file.push(files[0]);
      this.createFile(files[0]);
    },
    onChange(e) {
      var files = e.target.files;
      /*
     e.target.files.forEach(fajl =>{
         this.file.push(fajl);
         this.createFile(fajl);
      })
      */
      this.file.push(files[0]);
      this.createFile(files[0]);
    },

    createFile(file) {
      if (!file.type.match("image.*")) {
        alert("Select an image");
        return;
      }

      //this.upload()

      //var img = new Image();
      var reader = new FileReader();
      var vm = this;

      reader.onload = function(e) {
        vm.image.push(e.target.result);
      };

      reader.readAsDataURL(file);

      //this.upload();
    },
    removeFile(index) {
      this.image.splice(index, 1);
      this.file.splice(index, 1);
      if (this.image.length == 0 && this.description == "") {
        this.edit = false;
      }
      //this.uploading = false;
    },
    resetFile() {
      this.image = [];
      this.file = [];
      this.edit = false;
      this.description = "";
      //this.uploading = false;
    },
    upload() {
      //users from text
      this.usersNotify = [];
      var atSplit = this.description.split(/\s|\.|:|;|-|,|!/);
      atSplit.forEach(splitted => {
        if (splitted[0] == "@") {
          var exists = false;
          this.usersNotify.forEach(already => {
            if (already == splitted.slice(1)) {
              exists = true;
            }
          });
          if (!exists) {
            this.usersNotify.push(splitted.slice(1));
          }
        }
      });

      this.loading = true;
      this.uploading = true;

      //IF IMAGES INCLUDED
      let formData = new FormData();

      if (this.parentType == "Trades" || this.parentType == "Diary") {
        formData.append("owner", this.$route.params.name);
        //alert(this.$route.params.name)
      } else if (this.parentType == "Timeline") {
        formData.append("owner", this.$store.getters.username);
      }

      formData.append("parentType", this.parentType);
      formData.append("description", this.description);
      formData.append("parentId", this.parentId);
      formData.append("urlDate", this.$route.params.id);
      formData.append("subtype", this.subtype);
      this.file.forEach(fileItem => {
        formData.append("img", fileItem);
      });
      axios
        .post("https://tradeinpool.com:3001/api/add/message/", formData)
        .then(() => {
          this.clearEdit();
        });
    }
  }
};
</script>

<style scoped>
.image-upload > input {
  display: none;
}

.custom {
  background-color: #333b47 !important;
}

.rounded-card {
  padding-top: 3px;
}

.postInput input[type="text"] {
  margin-right: 15px;
  height: 40px !important;
  width: 100%;
  border-radius: 20px;
  border: 0px;
  padding-left: 21px;
  background-color: #333b47 !important;
  color: white;
  font-size: 12px;
}
.btn {
  border: 0;
  border-radius: 5px;
  color: #808f9c;
  height: 144px;
  cursor: pointer;
  display: inline-block;
  font-weight: bold;
  padding-top: 5px;
  transition: 0.2s;
  width: 100%;
}

.btn:hover {
  background-color: #1e242e;
  color: white;
}

.btn-hover {
  background-color: #1e242e;
}

input[type="file"] {
  position: absolute;
  opacity: 0;
  z-index: -1;
}

.align-center {
  text-align: center;
}

.helper {
  height: 100%;
  display: inline-block;
  vertical-align: middle;
  width: 0;
}

.hidden {
  display: none !important;
}

.hidden.image {
  display: inline-block !important;
}

.display-inline {
  display: inline-block;
  vertical-align: middle;
}

.img {
  display: inline-block;
  height: 100px;
  width: 100px;
}

.drop {
  border: 2px dashed #808f9c;
  border-radius: 5px;
  height: 150px;
  width: 100%;
}

.delete {
  position: absolute;
  margin-left: -120px;
  margin-top: -3px;
  width: 25px;
  height: 25px;
  background-color: black;
  border-radius: 50%;
  transition: 0.3s;
  cursor: pointer;
  color: black;
  z-index: 999;
}

.drag-right-out {
  position: fixed; /* important to use fixed, not absolute */
  top: 0;
  right: 0;
  width: 40px;
  height: 100%;
  z-index: 9999; /* may not be necessary 
  /*border: 1px solid red;*/
}
.drag-right-in {
  position: fixed; /* important to use fixed, not absolute */
  top: 0;
  right: 40px;
  width: 40px;
  height: 100%;
  z-index: 9999; /* may not be necessary */
  /*border: 1px solid blue;*/
}

.dimmer {
  background: black;
  opacity: 0.4;
  position: fixed; /* important to use fixed, not absolute */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10; /* may not be necessary */
  transition: 0.5s;
}
.dimmer-off {
  background: none;
  z-index: -10 !important; /* may not be necessary */
  position: fixed; /* important to use fixed, not absolute */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: 0.5s;
}

.totop {
  z-index: 9999 !important;
  min-height: 0px;
  transition: 0.5s;
}

.max-height {
  max-height: 1000px;
}
.totop-off {
  z-index: 0;
  max-height: 100px;
  transition: 0.2s;
}
</style>